<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="page-title">
          <span class="t-link" @click="$utils.redirect('#/equipment-list')">{{ $t("Equipments") }}</span>
          &nbsp;/&nbsp;
          <span v-if="!displayassociate && !show_modules">{{ device_name }}</span>
          <span v-else class="t-link" @click="displayassociate = false; show_modules = false;">{{ device_name }}</span>
          <span v-if="displayassociate">
            &nbsp;/&nbsp;
            {{ $t('Associate') }}
          </span>
          <span v-if="show_modules">
            &nbsp;/&nbsp;
            {{ $t('Modules order') }}
          </span>
        </h5>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <EquipmentHeader :device_name="device_name" :client_name="client_name" :maintenance_date="maintenance_date"
          :regulatory_target="regulatory_target" :software_version="software_version" :serial_number="serial_number"
          :location="''" :ventilation_board_serial_number="ventilation_board_serial_number"
          :pim_serial_number="pim_serial_number" :pim_mac_address_two="pim_mac_address_two"
          :pim_mac_address_one="pim_mac_address_one" :am_serial_number="am_serial_number"
          :displayactions="displayactions" @onassociate="associate" @onSendOrder="GetModules" />
      </b-col>
    </b-row>
    <br>
    <div v-if="show_modules">
      <b-row>
        <b-col>
          <b-card class="bg-t-dark">
            <b-row>
              <b-col>
                <h5>{{ $t("Modules configuration") }}</h5>
              </b-col>
            </b-row>
            <br>
            <b-row id="all-modules-wrapper">
              <b-col md="4" class="mt-3" v-for="m in all_modules" :key="m.id">
                <b-row>
                  <b-col>
                    <b-icon icon="record-circle" font-scale="1.3" class="cursor-pointer" v-if="m.active"
                      @click="moduleToggler(m)" />
                    <b-icon icon="circle" font-scale="1.3" class="cursor-pointer" v-else @click="moduleToggler(m)" />
                    &nbsp;
                    <span class="cursor-pointer" @click="moduleToggler(m)">{{ m.name }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br>
            <b-row align-h="end">
              <b-btn id="submit-update-order" class="col-md-2 mr-default" size="lg" variant="t-blue"
                @click="$bvModal.show('modules-submit-confirm')">
                {{ $t("Ok") }}
              </b-btn>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row v-if="!displayassociate">
        <b-col>
          <b-card class="bg-t-dark">
            <b-row>
              <b-col>
                <h5>{{ $t("Modules") }}</h5>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="4">
                <b-row v-for="m in modules" :key="m.id">
                  <b-col>
                    {{ m.name }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br>
            <b-row align-h="end">
              <b-btn class="col-md-3 mr-default" id="download-key-btn" size="lg" variant="t-blue" @click="downloadKey()"
                :disabled="activating || !configuration_code">
                <b-spinner small v-if="activating" />
                <b-icon-download v-else />
                &nbsp;
                {{ $t("Activation keys") }}
              </b-btn>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <b-card class="bg-t-dark">
            <b-row>
              <b-col>
                <h5>{{ $t("Fill in the data below to associate the equipment with the distributor:") }}</h5>
              </b-col>
            </b-row>
            <br>
            <b-row class="default-form">
              <b-col md="3">
                <small>
                  {{ $t('Distributor') }}
                </small>
                <br>
                <multiselect v-model="distributor" track-by="id" label="name" :options="distributors" selectLabel=""
                  @search-change="searchDistributors" @select="change_distributor"></multiselect>
              </b-col>
            </b-row>
            <h5 class="mt-3" v-if="distributor">
              {{ $t('Select an address') }}
            </h5>
            <b-row class="mt-3 mb-3" v-if="distributor">
              <b-col md="4" v-for="a, i, in address" :key="i">
                <b-row>
                  <b-col md="2">
                    <b-icon id="address-radio" :icon="address_id == a.id ? 'record-circle' : 'circle-fill'"
                      :variant="address_id == a.id ? 't-blue' : 'secondary'" font-scale="2" class="cursor-pointer"
                      @click="address_id = a.id" />
                  </b-col>
                  <b-col md="6">
                    <span class="cursor-pointer" @click="address_id = a.id">{{ a.description }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br v-if="distributor">
            <b-row v-if="distributor">
              <b-col md="4">
                <b-row>
                  <b-col md="2">
                    <b-icon :icon="address_id == null ? 'record-circle' : 'circle-fill'"
                      :variant="address_id == null ? 't-blue' : 'secondary'" font-scale="2" class="cursor-pointer"
                      @click="address_id = null" />
                  </b-col>
                  <b-col md="6">
                    <span id="include-new-address" class="cursor-pointer" @click="address_id = null">{{ $t('Include new
                      address')}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br>
            <div v-if="address_id == null && distributor">
              <b-row class="default-form">
                <b-col md="3" class="mt-2" id="country-multiselect">
                  <small>
                    {{ $t('Country') }}:
                  </small>
                  <br>
                  <multiselect class="mt-2" v-model="country" track-by="id" label="name" :options="countries"
                    @search-change="getCountries" selectLabel=""></multiselect>
                </b-col>
                <b-col md="3" class="mt-2">
                  <label>
                    {{ $t('Postal code') }}:
                  </label>
                  <b-form-input v-model="postal_code" id="postal-code-input" />
                  <small class="text-danger">
                    {{ erro_de_busca_cep }}
                  </small>
                </b-col>
                <b-col md="6" class="mt-2">
                  <label>
                    {{ $t('Street') }}:
                  </label>
                  <b-form-input disabled v-model="street" />
                </b-col>
                <b-col md="3" class="mt-2">
                  <label>
                    {{ $t('Number') }}:
                  </label>
                  <b-form-input id="number-input" v-model="number" />
                </b-col>
                <b-col md="4" class="mt-2">
                  <label>
                    {{ $t('Complement') }}:
                  </label>
                  <b-form-input id="complement-input" v-model="complement" />
                </b-col>
                <b-col md="4" class="mt-2">
                  <label>
                    {{ $t('District') }}:
                  </label>
                  <b-form-input disabled v-model="district" />
                </b-col>
                <b-col md="2" class="mt-2">
                  <small>
                    {{ $t('State') }}:
                  </small>
                  <br>
                  <b-form-input disabled v-model="province" />
                </b-col>
              </b-row>
            </div>
            <br>
            <b-row align-h="end">
              <b-btn id="confirm-associate-btn" class="col-md-3 mr-default" size="lg" variant="t-blue"
                @click="submitAssociate">
                &nbsp;
                {{ $t("Confirm Associate") }}
              </b-btn>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <br>
      <b-row v-if="!displayassociate">
        <b-col>
          <b-card class="bg-t-dark">
            <b-row>
              <b-col>
                <h5>{{ $t("History") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-for="h in history" :key="h.id">
              <b-col>
                <b-card class="bg-t-dark---">
                  <b-row>
                    <b-col>
                      <b-row>
                        <!-- 
                              h.history_date
                              h.history_change_reason
                              h.history_type
                              h.history_user
                              h.uid
                              h.action 
                            -->
                        <b-col md="3">
                          <h6>
                            {{ h.history_date }}
                          </h6>
                          <small>
                            {{ h.time }}
                          </small>
                        </b-col>
                        <b-col md="3">
                          {{ $t("Change reason") }}
                          <br>
                          <span class="text-green-">
                            ({{ h.history_type }}) {{ h.history_change_reason }}
                            <span v-if="h.action"> - {{ h.action }}</span>
                          </span>
                        </b-col>
                        <b-col md="3">
                          UID
                          <br>
                          <span class="text-green-">
                            {{ h.uid }}
                          </span>
                        </b-col>
                        <b-col md="3">
                          {{ $t("Responsible") }}
                          <br>
                          <span class="text-green-">
                            {{ h.history_user }}
                          </span>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal :id="`approvation-modal${order_id}`" centered size="md">
      <template #modal-title>
        Are you sure you want to release the modules?
      </template>
      <div>
        <b-row>
          <b-col>
            <b>Activations of the following modules will be released:</b>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illum in deserunt rer.
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <b-row align="end" align-h="end">
          <b-col>
            <b-btn variant="t-blue" @click="approve_confirmation">
              Release
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal :id="`approvation-success${order_id}`" hide-footer centered size="md">
      <template #modal-title>
        &nbsp;
      </template>
      <div>
        <b-row class="text-center">
          <b-col align="center">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="118" height="118" rx="49" fill="white" stroke="#C0C0C0" stroke-width="2" />
              <path
                d="M51.3802 71.9526L38.0473 58.6189L33.3333 63.333L51.3802 81.3807L88.0468 44.7141L83.3328 40L51.3802 71.9526Z"
                fill="#1F8B24" />
            </svg>
          </b-col>
        </b-row>
        <br>
        <b-row class="text-center mt-3">
          <b-col>
            <b>Modules released successfully!</b>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col>
            <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius nemo reiciendis, quae voluptatem
              quibusdam
              possimus eveniet mollitia fuga voluptatum deleniti sed sit.</span>
          </b-col>
        </b-row>
        <br>
        <br>
      </div>
    </b-modal>
    <b-modal :id="`modules-submit-confirm`" hide-footer centered size="lg">
      <template #modal-title>
        <h5>{{ $t("Confirm the changes") }}</h5>
      </template>
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col>
              <b>{{ $t("Before changes") }}</b>
            </b-col>
          </b-row>
          <br>
          <b-row v-for="m, i in all_modules_bkp" :key="i">
            <b-col style="white-space:nowrap;">
              <b-icon-check-square v-if="m.active" />
              <b-icon-square v-else />
              &nbsp;
              {{ m.name }}
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col>
              <b>{{ $t("After changes") }}</b>
            </b-col>
          </b-row>
          <br>
          <b-row v-for="m, i in all_modules" :key="i">
            <b-col style="white-space:nowrap;">
              <b-icon-check-square v-if="m.active" />
              <b-icon-square v-else />
              &nbsp;
              {{ m.name }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br>
      <b-row class=" justify-content-end">
        <b-btn id="ok-confirm-modules" class="col-md-2" variant="t-blue" @click="modules_order_submit"
          style="margin-right: 25px !important;">
          {{ $t("Ok") }}
        </b-btn>
      </b-row>
    </b-modal>
    <b-modal :id="`modules-submit-success`" hide-footer centered size="md">
      <template #modal-title>
        &nbsp;
      </template>
      <div>
        <b-row class="text-center">
          <b-col align="center">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="118" height="118" rx="49" fill="white" stroke="#C0C0C0" stroke-width="2" />
              <path
                d="M51.3802 71.9526L38.0473 58.6189L33.3333 63.333L51.3802 81.3807L88.0468 44.7141L83.3328 40L51.3802 71.9526Z"
                fill="#1F8B24" />
            </svg>
          </b-col>
        </b-row>
        <br>
        <b-row class="text-center mt-3">
          <b-col>
            <b>{{ $t("Modules order has created successfully!") }}</b>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col>
            <span>{{ $t("We will get back to you as soon as possible about your order.") }}</span>
          </b-col>
        </b-row>
        <br>
        <br>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import EquipmentHeader from "./components/EquipmentHeader.vue"
import backend from '@/api/backend'
import getAuthorization from '@/api/getAuthorization'
import fileDownload from 'js-file-download'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { activateDevice } from '@/api/featureServerApi'

export default {
  components: {
    EquipmentHeader,
    Multiselect
  },
  props: {
    order_id: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.equipment_id = this.$route.query.id
    this.$utils.request(
      `medicaldevice/device/${this.$route.query.id}/`,
      'GET',
      {},
      (r) => {
        // console.log(r.data)
        this.device_name = r.data.serial_number
        this.regulatory_target = r.data.regulatory_target.name
        this.regulatory_target_id = r.data.regulatory_target.id
        this.software_version = `${r.data.base_software.name} (${r.data.base_software.version})`
        this.serial_number = r.data.serial_number
        this.pim_serial_number = r.data.pim_serial_number
        this.pim_mac_address_two = r.data.pim_mac_address_two
        this.pim_mac_address_one = r.data.pim_mac_address_one
        this.am_serial_number = r.data.am_serial_number
        this.ventilation_board_serial_number = r.data.ventilation_board_serial_number
        if (r.data.entity) {
          this.client_name = r.data.entity.name
        }
        if (r.data.configuration) {
          this.configuration_code = r.data.configuration.code
          this.modules = [{
            id: r.data.configuration.id,
            name: `${r.data.configuration.name} - ${r.data.configuration.code}`,
            active: true,
          }]
        }
      },
      (r) => {
        this.$utils.customAlert(
          'Network error',
          'd'
        )
        this.$router.push('/equipment-list').catch(() => { })
      },
    )
    this.loadHistory()
    this.getCountries()
  },
  data() {
    return {
      ventilation_board_serial_number: '',
      erro_de_busca_cep: '',
      postal_code: '',
      pim_serial_number: null,
      pim_mac_address_two: null,
      pim_mac_address_one: null,
      am_serial_number: null,
      show_modules: false,
      modules: [],
      street: '',
      number: '',
      province: '',
      postalcode_id: null,
      district: '',
      complement: '',
      history: [],
      distributor: null,
      distributors: [
        // {
        //   id:1,
        //   name: 'Distributor 1'
        // },
        // {
        //   id:2,
        //   name: 'Distributor 2'
        // },
      ],
      address_id: null,
      address: [
      ],
      baseURL: backend.baseURL,
      equipment_id: null,
      device_name: "",
      client_name: "",
      maintenance_date: "",
      regulatory_target: "",
      regulatory_target_id: null,
      software_version: "",
      serial_number: "",
      configuration_code: null,
      activating: false,
      approved: false,
      displayassociate: false,
      displayactions: true,
      all_modules: [],
      all_modules_bkp: [],
      country: null,
      postal_code_format: '',
      countries: []
    }
  },
  methods: {
    change_distributor() {
      setTimeout(() => {
        try {
          document.getElementById('postal-code-input').addEventListener('keyup',
            this.$utils.debounce(this.postal_code_search, 450)
          )
        } catch (error) {
          console.log(error)
        }
      }, 1200);
    },
    moduleToggler(mod) {
      this.all_modules.forEach(m => {
        m.active = false
      })
      mod.active = true
    },
    submitAssociate() {
      if ((this.distributor != null) && !this.country && !this.postalcode_id && !this.address_id) {
        this.$utils.customAlert(
          'Check (country and postal code) fields',
          'w'
        )
      } else if (this.distributor == null) {
        this.$utils.customAlert(
          'Check Distributor field',
          'w'
        )
      } else if (this.address_id != null) {
        //cadastro com endereço existente
        this.$utils.request(
          `medicaldevice/device/${this.$route.query.id}/associate/`,
          'POST',
          {
            entity: this.distributor.id,
            location: this.address_id
          },
          (r) => {
            this.$utils.customAlert(
              'Associate success',
              's'
            )
            setTimeout(() => {
              window.location.reload()
            }, 1200);
          },
          (r) => {
            this.$utils.customAlert(
              'Network problem',
              'd'
            )
          }
        )
      } else if (this.postalcode_id != null) {
        //cadastro sem endereço existente
        this.$utils.request(
          `medicaldevice/device/${this.$route.query.id}/associate/`,
          'POST',
          {
            entity: this.distributor.id,
            address: {
              postalcode_id: this.postalcode_id,
              number: this.number,
              complement: this.complement,
            }
          },
          (r) => {
            this.$utils.customAlert(
              'Associate success',
              's'
            )
            setTimeout(() => {
              window.location.reload()
            }, 1200);
          },
          (r) => {
            this.$utils.customAlert(
              'Network problem',
              'd'
            )
          }
        )
      }
    },
    getCountries(search = '') {
      this.$utils.request(
        `account/country/?search=${search}`,
        'GET',
        {},
        (r) => {
          this.countries = []
          r.data.results.forEach(c => {
            this.countries.push({
              name: c.name,
              id: c.id,
              postal_code_format: c.postal_code_format
            })
          })
        }
      )
    },
    postal_code_search() {
      //verificar se é valido passar o país como parâmetro para filtrar os códigos postais
      if (this.postal_code && this.country.id) {
        this.$utils.request(
          `account/postalcode/?code=${this.postal_code}&country=${this.country.id}`,
          'GET',
          {},
          (r) => {
            if (r.data.results.length == 1) {
              const postal_code = r.data.results[0]
              this.postalcode_id = postal_code.id
              this.street = postal_code.subregion_name
              this.number = ''
              this.complement = ''
              this.district = postal_code.district_name
              this.province = postal_code.region_name
              this.erro_de_busca_cep = ''
            } else {
              if (r.data.results.length > 1) {
                if ((this.postal_code.length > 4)) {
                  const postal_code = r.data.results[0]
                  this.postalcode_id = postal_code.id
                  this.street = postal_code.subregion_name
                  this.number = ''
                  this.complement = ''
                  this.district = postal_code.district_name
                  this.province = postal_code.region_name
                  this.erro_de_busca_cep = ''
                }
              }
              if (r.data.results.length < 1) {
                this.erro_de_busca_cep = 'No zip code found'
              }
            }
          }
        )
      } else {
        if (this.postal_code_format.length != this.postal_code.length) {
          this.erro_de_busca_cep = 'Incomplete or invalid postal code'
          return
        }
        this.$utils.customAlert(
          this.erro_de_busca_cep,
          'd'
        )
      }
    },
    modules_order_submit() {
      // this.regulatory_target_id

      let active_modules = this.all_modules.filter(m => {
        return m.active
      })
      let modules_ids = []
      active_modules.forEach(am => {
        modules_ids.push(am.id)
      })
      let configuration = this.all_modules.filter(c => {
        return c.active
      })[0]
      if (active_modules.length > 0 && modules_ids.length > 0) {
        this.$utils.request(
          `medicaldevice/device/${this.$route.query.id}/update_configuration/`,
          'POST',
          {
            'configuration': configuration.id
          },
          (r) => {
            this.$bvModal.hide(`modules-submit-confirm`)
            this.$bvModal.show('modules-submit-success')
            setTimeout(() => {
              window.location.reload()
            }, 1200)
          },
          (r) => {
            console.log(r)
            this.$utils.customAlert(
              'Request error',
              'd'
            )
          }
        )
      } else {
        this.$utils.customAlert(
          'Select a configuration',
          'd'
        )
      }
    },
    GetModules() {
      // this.regulatory_target_id
      this.$utils.request(
        `medicaldevice/deviceconfig/?regulatory_target=${this.regulatory_target_id}`,
        'GET',
        {},
        (r) => {
          this.all_modules = []

          // action: null
          // available: true
          // available_at: "2022-09-01T23:34:49.921135Z"
          // code: "CE_BASE"
          // id: 2
          // modified_at: "2022-09-01T23:34:49.921092Z"
          // modified_by: 6
          // modules: [26]
          // name: "CE"
          // regulatory_target: 7

          r.data.forEach(m => {
            this.all_modules.push({
              active: this.modules.filter(i => { return i.id == m.id }).length > 0,
              name: m.name,
              id: m.id
            })
          })
          this.all_modules_bkp = [...JSON.parse(JSON.stringify(this.all_modules))]
          this.show_modules = true
          this.displayassociate = false
        }
      )
    },
    associate() {
      this.loadDistributors()
    },
    searchDistributors(search = '') {
      this.$utils.request(
        `account/entity/?search=${search}`,
        'GET',
        {},
        (r) => {
          this.distributors = []
          r.data.results.forEach(e => {
            this.distributors.push({
              address: e.address,
              id: e.id,
              name: e.name
            })
          })
          this.show_modules = false
          this.displayassociate = true
        },
        (r) => {
          this.$utils.customAlert(
            'Problem to get distributors list', 'd'
          )
        }
      )
    },
    loadDistributors() {
      this.$utils.request(
        `account/entity/`,
        'GET',
        {},
        (r) => {
          console.log(r.data)
          this.distributors = []
          r.data.results.forEach(e => {
            this.distributors.push({
              address: e.address,
              id: e.id,
              name: e.name
            })
          })
          this.show_modules = false
          this.displayassociate = true
        },
        (r) => {
          this.$utils.customAlert(
            'Problem to get distributors list', 'd'
          )
        }
      )
    },
    downloadKey() {
      if (!this.configuration_code) {
        this.$utils.customAlert(
          this.$t('No preset configuration found for this device'),
          'w'
        )
        return
      }
      this.activating = true
      const deviceIdentity = {
        equipment_serial_number: this.serial_number,
        pim_serial_number: this.pim_serial_number,
        am_serial_number: this.am_serial_number,
        ventilation_board_serial_number: this.ventilation_board_serial_number,
        pim_mac_address_one: this.pim_mac_address_one,
        pim_mac_address_two: this.pim_mac_address_two,
      }
      activateDevice(deviceIdentity, this.configuration_code)
        .then(async response => {
          // Save the full Feature Server response as-is (configFile + signature)
          // No decoding needed — the device expects the raw JSON
          const blob = new Blob(
            [JSON.stringify(response.data, null, 2)],
            { type: 'application/json' }
          )
          const filename = `${this.serial_number}.json`

          // Use File System Access API when available (bypasses Edge SmartScreen)
          if (window.showSaveFilePicker) {
            try {
              const handle = await window.showSaveFilePicker({
                suggestedName: filename,
                types: [{ description: 'JSON file', accept: { 'application/json': ['.json'] } }]
              })
              const writable = await handle.createWritable()
              await writable.write(blob)
              await writable.close()
            } catch (e) {
              if (e.name !== 'AbortError') {
                fileDownload(blob, filename)
              }
            }
          } else {
            // Fallback for browsers without File System Access API
            fileDownload(blob, filename)
          }

          await axios.post(
            `${backend.baseURL}medicaldevice/device/${this.$route.query.id}/log_activation_key_download/`,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                ...getAuthorization(),
              },
            }
          ).catch((error) => {
            console.warn('Unable to log activation key download in history', error)
          })

          // Reload history after successful download
          this.loadHistory()
        })
        .catch(error => {
          const status = error?.response?.status
          if (status === 403) {
            this.$utils.customAlert(
              this.$t('Preset unavailable for this device'),
              'w'
            )
          } else if (status === 400) {
            this.$utils.customAlert(
              this.$t('Invalid device identification'),
              'd'
            )
          } else {
            this.$utils.customAlert(
              this.$t('Error communicating with feature server'),
              'd'
            )
          }
        })
        .finally(() => {
          this.activating = false
        })
    },
    loadHistory() {
      this.$utils.request(
        `medicaldevice/devicehistory/${this.$route.query.id}/`,
        'GET',
        {},
        (r) => {
          this.history = []
          r.data.forEach(h => {
            this.history.push({
              history_date: new Date(h.history_date).toLocaleDateString(),
              history_change_reason: h.history_change_reason,
              history_type: h.history_type,
              history_user: h.history_user.name,
              uid: h.uid,
              time: new Date(h.history_date).toLocaleTimeString(),
              action: h.action,
            })
          })
        }
      )
    },
  },
  watch: {
    country(v) {
      console.log(v)
      this.postal_code_format = v.postal_code_format
    },
    distributor(v) {
      if (v.address) {
        this.address = []
        v.address.forEach(a => {
          let region = ''
          let region_code = ''
          let subregion_name = ''
          let number = ''
          let district_name = ''
          let postalcode = ''
          let country = ''

          try {
            region = a.postal_code.region.name
            region_code = a.postal_code.region.code
            subregion_name = a.postal_code.subregion_name
            number = a.number
            district_name = a.postal_code.district_name
            postalcode = a.postal_code.code
            country = a.postal_code.country.name
          } catch (error) {
            console.log(error)
          }

          this.address.push({
            id: a.id,
            description: `${region} / ${region_code} ${subregion_name}, ${number} ${district_name} ZIP-${postalcode} ${country}`
          })
        })
      }
    },
    displayassociate(v) {
      this.displayactions = !v
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.equipment-mode-select {
  .form-control {
    color: white;
    background: #767E8A;
    border: #767E8A50;
  }

  .form-control:focus {
    color: white;
    background: #767E8A;
    border: #767E8A50;
  }

  .form-select {
    background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
  }

  ::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
}

.multiselect__tags {
  background: #767E8A;
  border: none;
}

.multiselect__input {
  background: #767E8A;
}

.multiselect__single {
  background: #767E8A;
}

.multiselect__option--highlight {
  background: #767E8A;

}
</style>
